import { render, staticRenderFns } from "./Form5CaseInformation.vue?vue&type=template&id=40679bb3&scoped=true"
import script from "./Form5CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form5CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40679bb3",
  null
  
)

export default component.exports